
export const semanticTokens = {
  colors: {
    
  },
  shadows: {
    
  }
}